import { hasStringValue, politicsOtherFieldComparer, isSelected } from "@utilities";

const baseValidations = [
  {
    field: "clientProfile.0.data.clientPoliticsMember",
    validation: isSelected
  }
];

const clientPolitics = [
  {
    field: "clientPolitics.0.clientPoliticsList",
    validation: isSelected
  },
  {
    field: "clientPoliticsPosition.0.data.clientPoliticOtherInput",
    compareField: "clientPoliticsPosition.0.data.clientPoliticOther",
    validation: politicsOtherFieldComparer(false)
  },
  {
    field: "clientPolitics.0.data.clientPoliticsName",
    validation: hasStringValue
  },
  {
    field: "clientPolitics.0.data.clientPoliticsCountry",
    validation: hasStringValue
  },
  {
    field: "clientPolitics.0.data.pepInstitution",
    validation: hasStringValue
  },
  {
    field: "clientPolitics.0.data.clientPep_Id",
    validation: hasStringValue
  }
];

export const getStep4Validations = ({ validatePolitics = false }) => {
  return [...baseValidations, ...(validatePolitics ? clientPolitics : [])];
};
